import config from '@/config';
import { JsonLdScript } from '@/components/seo/JsonLdScript';
import {
  buildListingStructuredData,
  type ListingStructuredWork,
} from '@/features/seo-listing/utils/build-listing-structured-data';

type ListingStructuredBreadcrumb = {
  label: string;
  href?: string;
};

type ListingStructuredDataProps = {
  breadcrumbs: readonly ListingStructuredBreadcrumb[];
  heading: string;
  currentPath: string;
  works: readonly ListingStructuredWork[];
};

/** Visible catalog chain as BreadcrumbList, plus CollectionPage for the same URL. */
export function ListingStructuredData({
  breadcrumbs,
  heading,
  currentPath,
  works,
}: ListingStructuredDataProps) {
  if (breadcrumbs.length === 0) return null;
  const data = buildListingStructuredData({
    breadcrumbs,
    siteUrl: config.PUBLIC_URL,
    currentPageUrl: currentPath,
    heading,
    works,
  });
  return (
    <>
      <JsonLdScript data={data.breadcrumbList} />
      <JsonLdScript data={data.collectionPage} />
    </>
  );
}
